export default __webpack_public_path__ + "static/media/upload_picture.593e4da7.svg";